// TODO: implementēt, kad anketā parādīsies radio jautājumi
import React from 'react';

class RadioQuestion extends React.Component {
  selectOption = (e) => {
    const data = {};
    data[this.props.name] = e.target.value;
    this.props.setFormData(data);
  };

  render() {
    const options = [];
    for (let i = 0; i < this.props.options.length; i++) {
      options.push(
        <div key={this.props.options[i][this.props.valueKey]} className="form-group form-radio">
          <label>
            <input
              type="radio"
              name={this.props.name}
              value={this.props.options[i][this.props.valueKey]}
              title={this.props.options[i][this.props.label]}
              onChange={this.selectOption}
            />
            {this.props.options[i][this.props.label]}
          </label>
        </div>
      );
    }

    return (
      <div>
        {options}
      </div>
    );
  }
}

module.exports = RadioQuestion;
